const DEFAULT_MODE_RESET = 'DEFAULT_MODE/RESET';

export default function defaultModeResetAction() {
  return {
    type: DEFAULT_MODE_RESET,
    payload: {},
  };
}

export { DEFAULT_MODE_RESET };
